import { render, staticRenderFns } from "./EditRequestType.vue?vue&type=template&id=3e7c55c8"
import script from "./EditRequestType.vue?vue&type=script&lang=js"
export * from "./EditRequestType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports